module.exports = __webpack_public_path__ + "img/05.0116e5c7.png";